/* ============
 * Getters for the cronjob module
 * ============
 *
 * The getters that are available on the
 * cronjob module.
 */

export default {};
